module.exports = __webpack_public_path__ + "assets/img/3_1197_big.e4c823df.jpg";